<template>
  <div>
    <loader :loader="sending" />
    <v-data-table :headers="computedHeaders" :items="listHistoy" :items-per-page="itemsPerPage" :search="search"
      no-data-text="Sin resultados disponibles" class="mx-5" dense fixed-header height="auto" hide-default-footer>
      <template v-slot:[`item.intepretationDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.intepretationDate) }}
      </template>
      <template v-slot:[`item.startDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.startDate) }}
      </template>
      <template v-slot:[`item.nameInterpreter`]="{ item }">
        <span>
          {{ item.nameInterpreter }}
          <span v-if="item.validatorName !== ''">
            <br />
            <small style="font-style: italic; font-weight: bold;">Validó: <br /> {{ item.validatorName }}</small>
          </span>
        </span>
      </template>
      <template v-slot:[`item.birads`]="{ item }">
        <v-chip :color="getBiradsColor(item)" small>
          {{ getBiradsLabel(item) }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small icon @click="exportToPDF(item)"  v-if="$utilFront.withPermission($prm.INTERPRETATION_REPORT_DONWLOAD)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-file-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span> Descargar PDF </span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small icon @click="exportToPDF(item)"  v-if="$utilFront.withPermission($prm.DOWNLOAD_REPORT_REVALIDATE)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-file-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span> Descargar revalidación </span>
        </v-tooltip>
        <v-menu v-if="showMoreOptions(item)" >
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn small icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>Más opciones</span>
            </v-tooltip>
          </template>
          <!-- getDataEdit(item) -->
          <v-list dense>
            <v-list-item link @click="isEditableTable(item)" 
              v-if="$utilFront.withPermission($prm.INTERPRETATION_EDIT_ALL)">
              <v-list-item-icon>
                <v-icon color="warning"> mdi-pencil </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Editar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="isEditableTable(item)" 
              v-if="$utilFront.withPermission($prm.REVALIDATE_EDIT_ALL)">
              <v-list-item-icon>
                <v-icon color="warning"> mdi-pencil </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Revalidar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="downloadViewer(item.idStudy)" v-if="$utilFront.withPermission($prm.INTERPRETATION_VISUALIZER)">
              <v-list-item-icon>
                <v-icon color="amber"> mdi mdi-comment-eye </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Visualizador </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="downloadZIP(item)" v-if="$utilFront.withPermission($prm.DOWNLOAD_DICOM_INT)">
              <v-list-item-icon>
                <v-icon color="secondary"> mdi-folder-download </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> DICOM </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="changeViewAddendums(item)" v-if="$utilFront.withPermission($prm.INTERPRETATION_ATTACHED_FILES)">
              <v-list-item-icon>
                <v-icon color="cyan"> mdi-file-image </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Archivos anexos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <view-image-item :send="() => sending = !sending" :sending="sending" :idStudy="item.idStudy"
              v-if="$utilFront.withPermission($prm.VIEWER_WEB_INT)" />

          </v-list>
        </v-menu>
      </template>

  <template v-slot:[`item.revalidated`]="{ item }">
    {{ item.revalidated ? "REVALIDADO" : "NO REVALIDADO" }}
  </template>
    </v-data-table>
    <v-card-actions align="center">
      <v-col>
        <v-btn outlined small color="green darken-1" :disabled="sending" @click="downloadReportXLSX()">
          {{ sending ? "Exportando..." : "Exportar interpretaciones" }}
          <v-icon right>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-col>
    </v-card-actions>
    <v-dialog v-model="dialogCancelation" persistent max-width="70%" v-if="dialogCancelation">
      <cancelation-modal :dataModal="dataModal" @closeCancelationDialog="closeCancelationDialog"
        :dialogCancelation="dialogCancelation" />
    </v-dialog>
  </div>
</template>

<script>

import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import ViewImageItem from "@/app/components/common/study/ViewImageItem.vue";
import ColposcopyForm from "@/core/request/ColposcopyForm";
import { InterpretationHistoryService } from "@/app/services";

import {
  ReportPDFRequest,
  DownloadZipRequest,
  StudyRequest,
} from "@/core/request";
export default {
  name: "SpecialityTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    itemsPerPage: Number,
    biRadsSelect: Number,
    listAllPagination: Function,
    getAddendums: Function,
    search: String,
    range: Object,
    idBranchOffice: String,
    modalitiesSelect: String,
  },
  components: {
    MenuCrud,
    CancelationModal,
    Loader,
    ViewImageItem
  },
  data() {
    return {
      dialogCancelation: false,
      dataModal: {},
      listHistoy: [],
      sending: false,
      headers: [
        {
          text: "Id Interpretación",
          value: "idInterpretation",
          sortable: false,
          align: "center",
        },
        {
          text: "Id Estudio",
          value: "idStudy",
          align: "center",
          sortable: false,
        },
        {
          text: "Nombre del paciente",
          value: "patient",
          sortable: false,
          align: "center",
        },
        {
          text: "Modalidad",
          value: "modality",
          sortable: false,
          align: "center",
        },
        {
          text: "Estudio",
          value: "studyModality",
          sortable: false,
          align: "center",
        },
        {
          text: "BI-RADS",
          value: "birads",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha de interpretación",
          value: "intepretationDate",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha del estudio",
          value: "startDate",
          sortable: false,
          align: "center",
        },
        {
          text: "Intérprete",
          value: "nameInterpreter",
          sortable: false,
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width:"8%"
        },
      ],
    };
  },
  watch: {
    list: function () {
      this.setlistWithBiradsChanges();
    },
  },
 computed: {
  isMedicoInterpreteSupervisor() {
  const roleRaw = (this.$utilFront.getRole?.() || "");
  const role = roleRaw
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

  return role === "medico interprete supervisor";
},


  computedHeaders() {
    const h = [...this.headers];

    if (this.isMedicoInterpreteSupervisor) {
      const idx = h.findIndex(x => x.value === "birads");
      const extra = [{ text: "Estatus", value: "revalidated", sortable: false, align: "center" }];

      if (idx >= 0) h.splice(idx + 1, 0, ...extra);
      else h.push(...extra);
    }

    return h;
  },
},
  methods: {
    setlistWithBiradsChanges() {
      this.listHistoy = this.list.map((obj) => {
        obj.birads = obj.birads ? obj.birads : "NA";
        obj.colorBirads = obj.colorBirads ? obj.colorBirads : "nobirad";
        return obj;
      });
    },
    isEditableTable(item) {
  const isSupervisor = this.isMedicoInterpreteSupervisor;

  const interpretationIdToSend = isSupervisor
    ? item?.idInterpretationRevalidated
    : item?.idInterpretation;

  /* if (!interpretationIdToSend) {
    this.$utilFront.notifications(
      isSupervisor
        ? "No se encontró el idInterpretationRevalidated para este estudio."
        : "No se encontró el idInterpretation para este estudio.",
      "ERROR"
    );
    return;
  } */

  if (item?.modality && item.modality.toUpperCase() === "COLPOSCOPIA") {
    const payloadQuestions = {
      evaluationTypes: [13],
      idPerson: item.idPerson,
      idStudy: item.idStudy
    };

    ColposcopyForm.editColposcopyFormFromInterpretation(payloadQuestions)
      .then((respColposcopy) => {
        const newData = respColposcopy.data;

        const mappedData = newData.map((calculator) => {
          const mappedQuestions = calculator.dataQuestions.map((q) => {
            if (q.typeAnswer === 2 && q.idAnswer) q.answerClosed = q.idAnswer;
            return q;
          });

          return {
            idEvaluation: calculator.idCalculator,
            name: calculator.name,
            description: calculator.name,
            key: calculator.idCalculator,
            type: calculator.type,
            questions: mappedQuestions
          };
        });

        this.$emit("colposcopyLoaded", mappedData);
        return this.get(interpretationIdToSend, 3);
      })
      .catch((error) => {
        this.$utilFront.errorhttp(error);
      });
  } else {
    this.get(interpretationIdToSend, 3);
  }
},

showMoreOptions(item) {
  const canEdit = this.$utilFront.withPermission(this.$prm.INTERPRETATION_EDIT_ALL);
  const downloadReport = this.$utilFront.withPermission(this.$prm.INTERPRETATION_REPORT_DONWLOAD);
  const revalidateEdit = this.$utilFront.withPermission(this.$prm.REVALIDATE_EDIT_ALL);
  const downloadReportRevalidate = this.$utilFront.withPermission(this.$prm.DOWNLOAD_REPORT_REVALIDATE);
  const canViewer = this.$utilFront.withPermission(this.$prm.INTERPRETATION_VISUALIZER);
  const canDicom = this.$utilFront.withPermission(this.$prm.DOWNLOAD_DICOM_INT);
  const canAddendums = this.$utilFront.withPermission(this.$prm.INTERPRETATION_ATTACHED_FILES);
  const canWebViewer = this.$utilFront.withPermission(this.$prm.VIEWER_WEB_INT);

  // si alguna opción además depende de item, agrégalo aquí
  // ej: const canViewerThisRow = canViewer && !!item.idStudy;

  return canEdit || canViewer || canDicom || canAddendums || canWebViewer || revalidateEdit || downloadReport || downloadReportRevalidate;
},

getBiradsLabel(item) {
  if (this.isMedicoInterpreteSupervisor) {
    // Si es supervisor: si no hay revalidación -> N/A
    return item?.biradsRevalidation ?? "N/A";
  }
  // Si no es supervisor: muestra el BI-RADS normal
  return item?.birads || "NA";
},

getBiradsColor(item) {
  if (this.isMedicoInterpreteSupervisor) {
    // Si es supervisor: color de revalidación o uno neutro si no hay
    return item?.colorBiradsRevalidation ?? "nobirad";
  }
  return item?.colorBirads || "nobirad";
},




    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeCancelationDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
    downloadViewer(item) {
      try {
        this.sending = true;
        let data = {
          idStudy: item,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        };
        StudyRequest.findURLJNLP(data)
          .then((res) => {
            window.open(res.data, "_blank").focus();
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
  downloadZIP(item) {
  this.sending = true;
  try {
    let data = { idStudy: item.idStudy };
    DownloadZipRequest.downloadImagesDCM(data)
      .then((res) => {
        let filename = '';
        
        if (item.patient && item.idPatient) {
          const nameParts = item.patient.trim().split(/\s+/).filter(part => part !== '');
          const numParts = nameParts.length;
          
          if (numParts === 1) {
            filename = `${nameParts[0]} - ${item.idPatient}.zip`;
          } else if (numParts === 2) {
            const apellidoPaterno = nameParts[1];
            const nombres = nameParts[0];
            filename = `${apellidoPaterno}${nombres} - ${item.idPatient}.zip`;
          } else {
            let apellidosCount;
            
            if (numParts === 3) {
              apellidosCount = 2;
            } else if (numParts === 4) {
              apellidosCount = 2;
            } else {
              apellidosCount = 2;
            }
            
            const apellidos = nameParts.slice(-apellidosCount);
            const nombres = nameParts.slice(0, -apellidosCount).join('');
            
            const apellidoPaterno = apellidos[0];
            const apellidoMaterno = apellidos[1] || '';
            const apellidosCompletos = apellidoPaterno + apellidoMaterno;
            
            filename = `${apellidosCompletos}${nombres} - ${item.idPatient}.zip`;
          }
        } else {
          filename = `${item.idPatient}.zip`;
        }

        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/zip",
          })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 60000);
      })
      .catch(this.catchError)
      .finally(() => {
        this.sending = false;
      });
  } catch (e) {
    this.catchError(e);
  }
},
   exportToPDF(interpretation) {
  this.sending = true;
  
  let data = {
    idInterpretation: interpretation.idInterpretation,
    interpretationText: "",
    fileName: "Interpretacion",
  };
  
  ReportPDFRequest.downloadInterpretation1(data).then((res) => {
    // Construir el nombre del archivo con el formato: ApellidoPaternoApellidoMaternoNombres - ID.pdf
    let filename = '';
    let displayName = '';
    
    if (interpretation.patient && interpretation.idPatient) {
      const nameParts = interpretation.patient.trim().split(/\s+/).filter(part => part !== '');
      const numParts = nameParts.length;
      
      if (numParts === 1) {
        filename = `${nameParts[0]} - ${interpretation.idPatient}.pdf`;
        displayName = `${nameParts[0]} - ${interpretation.idPatient}`;
      } else if (numParts === 2) {
        // Un nombre y un apellido: "Juan Pérez"
        const apellidoPaterno = nameParts[1];
        const nombres = nameParts[0];
        filename = `${apellidoPaterno}${nombres} - ${interpretation.idPatient}.pdf`;
        displayName = `${apellidoPaterno}${nombres} - ${interpretation.idPatient}`;
      } else {
        // 3 o más partes: determinar apellidos
        let apellidosCount;
        
        if (numParts === 3) {
          // Ejemplo: "María García López" -> 1 nombre, 2 apellidos
          apellidosCount = 2;
        } else if (numParts === 4) {
          // Ejemplo: "José Luis Hernández García" -> 2 nombres, 2 apellidos
          apellidosCount = 2;
        } else {
          // Para 5+ partes: 2 apellidos, el resto nombres
          apellidosCount = 2;
        }
        
        // Los últimos elementos son los apellidos (primero el paterno, luego el materno)
        const apellidos = nameParts.slice(-apellidosCount);
        // El resto son nombres
        const nombres = nameParts.slice(0, -apellidosCount).join('');
        
        // Orden correcto: apellido paterno + apellido materno + nombres
        const apellidoPaterno = apellidos[0];
        const apellidoMaterno = apellidos[1] || '';
        const apellidosCompletos = apellidoPaterno + apellidoMaterno;
        
        filename = `${apellidosCompletos}${nombres} - ${interpretation.idPatient}.pdf`;
        displayName = `${apellidosCompletos}${nombres} - ${interpretation.idPatient}`;
      }
    } else {
      filename = `Interpretacion-${interpretation.idInterpretation}.pdf`;
      displayName = `Interpretacion-${interpretation.idInterpretation}`;
    }

    const pdfBlob = new Blob([res.data], {
      type: "application/pdf",
    });
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Crear una página HTML que muestre el PDF con el título personalizado
    const htmlContent = `
<!DOCTYPE html>
<html>
<head>
    <title>${displayName}</title>
    <style>
        body, html {
            margin: 0;
            padding: 0;
            height: 100%;
            overflow: hidden;
        }
        embed {
            width: 100%;
            height: 100%;
            border: none;
        }
    </style>
</head>
<body>
    <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
</body>
</html>`;

    const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
    const htmlUrl = URL.createObjectURL(htmlBlob);

    // Abrir la página HTML en una nueva pestaña
    window.open(htmlUrl, '_blank');

    // También ofrecer la descarga directa con el nombre correcto
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Limpiar las URLs después de un tiempo
    setTimeout(() => {
      URL.revokeObjectURL(pdfUrl);
      URL.revokeObjectURL(htmlUrl);
    }, 60000);

    this.sending = false;
  }).catch(error => {
    this.sending = false;
    this.catchError(error);
  });
},
    changeViewAddendums(item) {
      this.sending = true;
      this.objectInterpretation = item;
      this.getAddendums(item, 1);
    },
    downloadReportXLSX() {
      if (!this.sending) {

        this.sending = true;

        let params = {
          idBirads: this.biRadsSelect,
          search: this.search,
          idBranchOffice: this.idBranchOffice != null ? this.idBranchOffice : this.$utilFront.getIdBranchOffice(),
        };

        if (this.$utilFront.nonEmpty(this.modalitiesSelect)) {
          params.idModality = this.modalitiesSelect;
        }

        let rangeName = "";

        if (this.$utilFront.nonEmpty(this.range)) {
          params.start = this.$utilFront.startOfDay(this.range.start);
          params.end = this.$utilFront.endOfDay(this.range.end);
          rangeName = ` del ${this.$utilFront.formatDate(params.start)} al ${this.$utilFront.formatDate(params.end)}`;
        }




        let fileName = `Historial de interpretaciones${rangeName}.xlsx`;

        InterpretationHistoryService.downloadReportHistoryXLSX(params).then((response) => {
          let { data } = response;
          this.$utilFront.downloadXLSX(data, fileName);
        }).catch((error) => {
          this.$utilFront.errorhttp(error);
        }).finally(() => {
          this.sending = false;
        });
      }
    },
  },
};
</script>
